module.exports = __webpack_public_path__ + "img/f-thermometer-img2-2.f510e358.png";